import React, { FC, useEffect } from 'react';

import './CopyLinkModal.scss';

import TemplateModal from 'components/common/modals/TemplateModal';
import Button from 'components/common/ui-kit/Button';
import Link from 'components/common/ui-kit/Link';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import useCopyLink from 'hooks/statements/useCopyLink';
import terms, { isRussianLocale } from 'i18n';
import { EntranceTest } from 'models/applications/entrance-tests';
import { createToast } from 'redux/actions';
import { supportApi } from 'redux/api/common/support-api';
import { modalDataSelector } from 'redux/selectors';
import { getLocalDateTimeFormattedString } from 'utils/date';

type ModalData = EntranceTest & {
  userId: number;
};

const CopyLinkModal: FC = () => {
  const { isCopied, copyToClipboard } = useCopyLink(2000);
  const dispatch = useAppDispatch();

  const examData = useAppSelector(modalDataSelector) as ModalData | undefined;
  console.log('examData:', examData);

  const userId = examData?.userId;
  console.log('userId: ', userId);

  const scheduleId = examData?.scheduleId;

  const subjectTitle = examData?.subject
    ? isRussianLocale()
      ? examData.subject.title
      : examData.subject.titleForeign
    : 'Предмет не указан';

  const examTime = examData?.datetime
    ? getLocalDateTimeFormattedString(examData.datetime)
    : 'Время не указано';

  const [generateExamLink, { data: examLink, isLoading }] =
    supportApi.useLazyGenerateExamLinkQuery();

  useEffect(() => {
    if (userId && scheduleId) {
      generateExamLink({ userId, scheduleId })
        .unwrap()
        .catch(e => {
          let messageRu;
          if (typeof e.data === 'string') {
            try {
              const parsed = JSON.parse(e.data);
              messageRu = parsed.messageRu;
            } catch {
              messageRu = null;
            }
          } else if (e.data && typeof e.data === 'object') {
            messageRu = e.data.messageRu;
          }

          if (e.status === 400 && messageRu) {
            dispatch(createToast(messageRu, 'danger'));
          } else {
            dispatch(createToast(terms.ERROR_HAS_OCCURRED, 'danger'));
          }
        });
    }
  }, [userId, scheduleId]);

  console.log('examlink: ', examLink);

  const handleCopy = async () => {
    if (examLink) {
      const success = await copyToClipboard(examLink);

      if (success) {
        localStorage.setItem('lastExamLink', examLink);
      }
    }
  };

  return (
    <TemplateModal title="Ссылка на экзамен">
      <div className="exam-link-modal">
        <div>
          <div className="info-row">
            <span className="info-label">Предмет:</span>
            <span className="info-value">{subjectTitle}</span>
          </div>

          <div className="info-row">
            <span className="info-label">Время:</span>
            <span className="info-value">{examTime}</span>
          </div>

          <div className="info-row">
            <span className="info-label">Ссылка:</span>
            <div className="link-wrapper">
              {examLink ? (
                <Link href={examLink} target="_blank">
                  {examLink}
                </Link>
              ) : (
                <span className="no-link">Ссылка недоступна</span>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-actions">
        <Button theme="success" onClick={handleCopy} disabled={!examLink}>
          {isCopied ? 'Скопировано!' : 'Копировать ссылку'}
        </Button>
      </div>
    </TemplateModal>
  );
};

export default CopyLinkModal;
